document.addEventListener('DOMContentLoaded', async function () {
  if (window.location.pathname === '/pages/halfoff') {
    try {
      const productVariantId = 42980829626461;

      const checkCart = async () => {
        const response = await fetch('/cart.js', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        });
        return await response.json();
      };

      const initialCart = await checkCart();
      const existingItem = initialCart.items.find((item) => item.variant_id === productVariantId);

      if (existingItem) {
        if (existingItem.quantity !== 1) {
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              updates: {
                [productVariantId]: 1,
              },
            }),
          });
        }
      } else {
        const productData = {
          items: [
            {
              id: productVariantId,
              quantity: 1,
            },
          ],
          sections: 'cart-notification-product,cart-notification-button,cart-icon-bubble',
        };

        await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          credentials: 'same-origin',
          body: JSON.stringify(productData),
        });
      }

      await new Promise((resolve) => setTimeout(resolve, 1500));
    } catch (error) {
      console.error('Erro:', error);
    }
  }
});
